import { render } from "./UserBlock.vue?vue&type=template&id=4e8a5cb8&scoped=true"
import script from "./UserBlock.vue?vue&type=script&lang=js"
export * from "./UserBlock.vue?vue&type=script&lang=js"

import "./UserBlock.vue?vue&type=style&index=0&id=4e8a5cb8&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e8a5cb8"]])

export default __exports__